import { useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useFormik } from "formik";

// @material-ui/core components
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  FormLabel,
  Grid,
  TextField,
  FormControlLabel,
  FormGroup,
  Switch,
} from "@material-ui/core";

// Karsten
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import MaskAndValid from "utils/maskAndValid";
import Api from "lib/api/httpRequestHelper";

export default function DialogMotivosFalhas({
  open,
  formType,
  onClose,
  selectedReason,
  onCreated,
}) {
  const [submitting, setSubmitting] = useState(false);
  const snackbar = useSnackbar();

  const submit = async (values) => {
    const { descricao, status } = values;

    setSubmitting(true);

    if (formType === "edit") {
      return await Api.put(
        "edit-fail-motive",
        "weave",
        {
          idMotivoFalha: selectedReason.IdMotivoFalha.toString(),
          status: status.toString(),
          descricao,
        },
        true
      )
        .then((res) => {
          if (res.Success) {
            snackbar.showMessage(`Motivo de falha editado com sucesso!`, {
              severity: "success",
            });
            handleClose(res.Result);
          } else {
            snackbar.showMessage(
              `Ocorreu um erro ao editar o motivo de falha. Verifique os parâmetros informados.`,
              {
                severity: "error",
              }
            );
            setSubmitting(false);
          }
        })
        .catch((error) => {
          snackbar.showMessage(error, {
            severity: "error",
          });
          setSubmitting(false);        });
    } else {
      return await Api.post(
        "create-fail-motive",
        "weave",
        {
          descricao,
        },
        true
      )
        .then((res) => {
          if (res.Success) {
            snackbar.showMessage(`Motivo de falha cadastrado com sucesso!`, {
              severity: "success",
            });
            handleClose(res.Result);
            onCreated("true");
          } else {
            snackbar.showMessage(
              `Ocorreu um erro ao cadastrar o motivo de falha. Verifique os parâmetros informados.`,
              {
                severity: "error",
              }
            );
            setSubmitting(false);
          }
        })
        .catch((error) => {
          snackbar.showMessage(error, {
            severity: "error",
          });
          setSubmitting(false);        });
    }
  };

  const formik = useFormik({
    initialValues: {
      descricao: selectedReason?.DescMotivoFalha || "",
      status: selectedReason?.StatusMotivoFalha || false,
    },
    onSubmit: submit,
  });

  const { values, handleChange, handleSubmit, dirty, resetForm } = formik;

  const handleClose = (editedReason) => {
    resetForm();
    onClose(editedReason);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
      >
        <form onSubmit={handleSubmit}>
          <DialogTitle>
            <span>
              <Typography id="alert-dialog-title" variant="h3" component="h3">
                {`${
                  formType === "edit" ? "Editar" : "Cadastrar"
                } Motivo de Falha`}
              </Typography>
            </span>
          </DialogTitle>
          <PerfectScrollbar>
            <DialogContent style={{ padding: "1rem 1.5rem 1.5rem" }}>
              <>
                <Grid container>
                  <Grid item xs={12}>
                    <FormGroup>
                      <FormLabel required>Descrição</FormLabel>
                      <TextField
                        name="descricao"
                        required
                        fullWidth
                        disabled={submitting}
                        value={values.descricao}
                        variant="outlined"
                        onChange={handleChange}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .toString()
                            .slice(0, 250);
                        }}
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12}>
                    {formType === "edit" && (
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={values.status}
                              onChange={handleChange}
                              name="status"
                              disabled={submitting}
                            />
                          }
                          label={<FormLabel required>Ativo?</FormLabel>}
                          labelPlacement="top"
                          style={{ alignItems: "flex-start", marginLeft: 0 }}
                        />
                      </FormGroup>
                    )}
                  </Grid>
                </Grid>
              </>
              {submitting && (
                <div style={{ marginTop: "1rem" }}>
                  <span>{`${
                    formType === "create" ? "Cadastrando" : "Editando"
                  } motivo de falha...`}</span>
                  <LinearProgress />
                </div>
              )}
            </DialogContent>
          </PerfectScrollbar>
          <DialogActions>
            <Button component={Box} onClick={handleClose} disabled={submitting}>
              Cancelar
            </Button>

            <Button
              color="default"
              variant="contained"
              type="submit"
              disabled={
                submitting ||
                !dirty ||
                MaskAndValid.isNullOrEmpty(values.descricao)
              }
            >
              {formType === "edit" ? "Atualizar" : "Cadastrar"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
